<div class="overview-refurb-msg" *ngIf="data">
    <div class="dynamic-html warn" [innerHTML]="data.msg"></div>
</div>
